import { memo } from "react"
import { DTO_MobileProfile } from "../../../../../../services/calls/types/mobiles"
import { MOBILE_PROFILE_MAP, MobileInfo } from "./data"
import InfoDisplay from "../../../../../../components/InfoDisplay"

import './index.scss'
import { DateTime } from "luxon"
import { useTranslation } from "react-i18next"

type MobileProfile = {
  data: DTO_MobileProfile
}

const MobileProfile = memo(({ data }: MobileProfile) => {
  const { t } = useTranslation()

  const formatFunction = (value: any, mapInfo: MobileInfo) => {
    if (mapInfo.id === 'milage') {
      return `${Math.round(value).toLocaleString()} km`
    } else if (mapInfo.id === 'insurance_status') {
      return value ? t('Insured') : t('Not insured')
    } else if (mapInfo.type === 'date') {
      return DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT)
    } else if (mapInfo.type === 'temp') {
      const time = DateTime.fromISO(value.datadate).toLocaleString(DateTime.DATETIME_MED)
      const temperature = parseFloat(value.temperature).toFixed(1)
      return `${temperature}˚C ${time}`
    }
    return value
  }
  
  return (
    <div className="MobileProfile">
      {Object.values(MOBILE_PROFILE_MAP).map((val) => {
        const isVisible = typeof val?.visible !== 'undefined' ? val.visible(data) : true
        if (!isVisible) return null
        const infoArr = val?.data.map((d) => {
          const { path, source, label, index, type } = d
          let value = data[path] ?? null
          if (source === 'automobile') value = data.automobile[path]
          if (source === 'all_fleets') value = data.all_fleets.map((v) => v[path])
          if (source === 'sensor') value = data.sensor[index ?? 0]?.[path]
          
          value = formatFunction(value, d)
          if (type === 'img') return { label, value, type }
          return { label, value }
        })
        return (
          <InfoDisplay label={val.label} data={infoArr} />
        )
      })}
    </div>
  )
})

export default MobileProfile
